import { cn } from "@gigpro/ui/tailwind/cn";
import type * as React from "react";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  ref?: React.Ref<HTMLTextAreaElement>;
  /**
   * Apply error styling to the input.
   */
  invalid?: boolean;
}

const Textarea = ({ ref, className, disabled, invalid, ...props }: TextareaProps) => (
  <textarea
    className={cn(
      "flex max-h-48 min-h-16 w-full rounded-sm border-2 bg-white px-3 py-2 text-large text-black outline-none placeholder:text-medium-gray focus:border-brand disabled:cursor-not-allowed disabled:opacity-50",
      disabled && "bg-background",
      /**
       * Order of the border color definitions below matters.
       * Focused should take priority over default, and error should take priority over both.
       */
      (!invalid || disabled) && "border-medium-gray",
      invalid && !disabled && "border-error",
      className,
    )}
    ref={ref}
    disabled={disabled}
    {...props}
  />
);
Textarea.displayName = "Textarea";

export { Textarea };
